import { render } from "./ProjectPhaseStatus.vue?vue&type=template&id=bb4112a4"
import script from "./ProjectPhaseStatus.vue?vue&type=script&lang=js"
export * from "./ProjectPhaseStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__